// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"ff874799","787":"76e1d7f0"}[chunkId] + ".chunk.js";
};